import { useAuthStore } from '@/stores/authStore';
import { hasConfirmedGrant } from '@/stores/grants';

/**
 * Whether the current trader may use the oscar overtake/blocker flow.
 * Resolved relay-side (GET /api/trader/me → `oscarAccess`, from
 * traderRules.oscarEnabled — fail-closed) and threaded onto the session by
 * refreshMe(). Defaults to false on a stale/missing read so the oscar UI
 * never leaks before access lands. The relay enforces the same flag on
 * POST /api/kalshi/order-sequence — this hook is display gating only.
 */
export function useOscarAccess(): boolean {
  return useAuthStore((s) => hasConfirmedGrant(s.user, 'oscarAccess'));
}
